<template>
  <component
    :is="as"
    :class="['stat-item', size]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <label>{{ label }}</label>

    <div class="value">
      <slot name="before" />
      <span v-show="!hasEmptyValue" :class="{ success, warning, error }">{{ displayValue }}</span>
      <slot name="after" />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    as: {
      type: String,
      default: 'div',
    },
    label: String,
    value: [String, Number],
    hasEmptyValue: Boolean,
    success: Boolean,
    warning: Boolean,
    error: Boolean,
    size: {
      type: String,
      default: 'regular',
    },
  },

  computed: {
    displayValue() {
      return this.value === undefined || this.value === null || this.value === ''
        ? 'N/A'
        : this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.stat-item {
  @include ellipsis;
  display: inline-flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--theme-color);
  text-decoration: none;

  &.large {
    @media($medium-up) {
      label {
        font-size: 16px;
      }

      span {
        font-size: 22px;
      }
    }
  }

  &.xlarge {
    label {
      font-size: 16px;
    }

    span {
      font-size: 22px;
    }

    @media($medium-up) {
      label {
        font-size: 24px;
      }

      span {
        font-size: 42px;
      }
    }
  }
}

.value {
  display: inline-flex;
  align-items: center;
  gap: $gp * .3;
  justify-content: var(--stat-item-justify, flex-start);
}

label {
  font-size: 12px;
  margin-bottom: var(--stat-item-label-margin, #{$gp * -0.25});
  white-space: nowrap;
}

span {
  font-family: $font-family-secondary;
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 700;
}

a.stat-item:hover {
  span {
    text-decoration: underline;
  }
}
</style>
